<section class="hero" id="start" aria-label="Wprowadzenie" [class.is-transitioning]="isBranchImageTransitioning">
  <div class="hero-copy">
    <p class="branch-status" [class.is-open]="isSelectedBranchOpen" [class.is-closed]="!isSelectedBranchOpen">
      <span class="branch-status-dot"></span>
      {{ activeBranch.title }} · {{ branchStatusText }}
    </p>
    <h1>Opieka weterynaryjna <span class="nowrap">blisko Ciebie</span></h1>
    <p class="hero-lead">
      Dwie filie, jeden standard leczenia i diagnostyki.<br>
      Wybierz lokalizację, żeby skontaktować się<br>
      z zespołem najbliżej odpowiadającym Państwa lokalizacji i potrzebom.
    </p>
    <div class="hero-actions">
      <a class="btn btn-primary" href="#kontakt">Kontakt</a>
    </div>
  </div>
  <div class="hero-gallery" aria-hidden="true">
    <img
      class="hero-gallery-layer hero-gallery-prev"
      [src]="previousBranchImage.src"
      [attr.srcset]="previousBranchImage.srcSet"
      sizes="100vw"
      alt=""
      loading="lazy"
      decoding="async" />
    <img
      class="hero-gallery-layer hero-gallery-current"
      [src]="currentBranchImage.src"
      [attr.srcset]="currentBranchImage.srcSet"
      sizes="100vw"
      alt=""
      loading="eager"
      decoding="async"
      fetchpriority="high" />
  </div>
</section>

<section class="branch-sticky" aria-label="Przełącznik filii">
  <div class="branch-sticky-inner">
    <div class="branch-switch" role="tablist" aria-label="Wybór filii">
      <button
        *ngFor="let branchId of branchOrder"
        type="button"
        class="switch-btn"
        [class.is-active]="selectedBranch === branchId"
        (click)="selectBranch(branchId)">
        {{ branches[branchId].title }}
      </button>
    </div>
  </div>
</section>

<section class="branch-panel" aria-label="Filie gabinetu">
  <p class="branch-label">
    {{
      selectedBranch === 'mogilany'
        ? 'KONTAKT DO GABINETU W MOGILANACH'
        : 'KONTAKT DO PRZYCHODNI WETERYNARYJNEJ W ŚWIĄTNIKACH GÓRNYCH'
    }}
  </p>
  <div class="branch-summary">
    <article class="branch-card branch-card-active">
      <h3>Adres i godziny otwarcia</h3>
      <p>{{ activeBranch.address }}</p>
      <div class="hours-block" *ngIf="activeBranch.hours?.length">
        <p class="hours-title">Godziny:</p>
        <ul class="hours-list">
          <li *ngFor="let hour of activeBranch.hours">{{ hour }}</li>
        </ul>
      </div>
    </article>

    <article class="branch-card branch-card-active">
      <h3>Kontakt</h3>
      <p><strong>{{ activeBranch.phoneLabel }}:</strong> {{ activeBranch.phoneDisplay }}</p>
      <p *ngIf="activeBranch.extraPhone"><strong>Dodatkowy telefon:</strong> {{ activeBranch.extraPhone }}</p>
      <a class="inline-link" href="#kontakt">Przejdź do kontaktu tej filii</a>
    </article>
  </div>
</section>

<section class="key-points" aria-label="Skrót informacji">
  <article>
    <h3>Od 2011 roku</h3>
    <p>Działamy nieprzerwanie, łącząc doświadczenie kliniczne z uważną komunikacją.</p>
  </article>
  <article>
    <h3>Diagnostyka na miejscu</h3>
    <p>Badania laboratoryjne, USG i RTG skracają czas od objawów do decyzji terapeutycznej.</p>
  </article>
  <article>
    <h3>Dwie lokalizacje</h3>
    <p>Spójna opieka w Mogilanach i Świątnikach Górnych, z szybkim przejściem do map i telefonu.</p>
  </article>
</section>

<section class="section branch-focus" id="filia">
  <div class="section-head">
    <p class="eyebrow">Wybrana filia</p>
    <h2 class="branch-focus-heading">{{ activeBranch.kind }} {{ activeBranch.title }}: najważniejsze informacje</h2>
  </div>
  <article class="editorial-card">
    <ul class="scope-list">
      <li *ngFor="let item of activeBranch.scope">{{ item }}</li>
    </ul>
  </article>
</section>

<section class="section about" id="onas">
  <div class="section-head">
    <p id="onas-heading" class="eyebrow anchor-target">O nas</p>
    <h2 class="about-heading">Opieka medyczna, która zostawia miejsce na rozmowę</h2>
  </div>
  <div class="about-layout">
    <article class="editorial-card">
      <p>
        Nasza przychodnia działa od 2011 roku. Tworzymy zespół lekarzy i personelu medycznego,
        który każdego dnia dba o zdrowie i bezpieczeństwo zwierząt.
      </p>
      <p>
        Prowadzimy diagnostykę, leczenie, profilaktykę i opiekę okołozabiegową.
        Część diagnostyki realizujemy na miejscu, aby skrócić czas oczekiwania.
      </p>
      <p>
        Wspieramy opiekunów zarówno w codziennej profilaktyce, jak i w trudnych momentach
        związanych z ciężką chorobą lub leczeniem paliatywnym.
      </p>
      <p>
        W roku 2024 świadczymy także usługi weterynaryjne w gabinecie w Mogilanach.
      </p>
    </article>
    <aside class="quote-card">
      <p>
        "W leczeniu liczy się nie tylko trafna diagnoza. Liczy się też sposób,
        w jaki przeprowadzamy opiekuna przez kolejne decyzje."
      </p>
      <span>Zespół</span>
    </aside>
  </div>
</section>

<section class="section team" id="zespol">
  <div class="section-head">
    <p id="zespol-heading" class="eyebrow anchor-target">Zespół</p>
    <h2 class="team-heading">Zespół filii: {{ activeBranch.title }}</h2>
  </div>

  <div class="team-grid">
    <article class="team-card">
      <h3>{{ activeBranch.kind }} {{ activeBranch.title }}</h3>
      <ul>
        <li *ngFor="let person of activeBranch.team">{{ person }}</li>
      </ul>
      <p>{{ activeBranch.teamNote }}</p>
    </article>
  </div>
</section>

<section class="section services" id="uslugi">
  <div class="section-head">
    <p id="uslugi-heading" class="eyebrow anchor-target">Usługi</p>
    <h2 class="services-heading">Nasze usługi</h2>
  </div>

  <div class="services-grid">
    <article>
      <h3><img class="service-icon" src="assets/service-icons/konsultacje.svg" alt="" aria-hidden="true">Konsultacje i badania</h3>
      <p>Kompleksowe badanie Twojego pupila w spokojnej atmosferze. Diagnozujemy, doradzamy i planujemy leczenie - zawsze z myślą o komforcie zwierzaka i Twoim spokoju.</p>
    </article>
    <article>
      <h3><img class="service-icon" src="assets/service-icons/szczepienia.svg" alt="" aria-hidden="true">Szczepienia i profilaktyka</h3>
      <p>Regularne szczepienia i odrobaczanie to najprostszy sposób, by uchronić pupila przed groźnymi chorobami. Przypomnimy o terminach i dobierzemy plan pod wiek oraz tryb życia zwierzaka.</p>
    </article>
    <article>
      <h3><img class="service-icon" src="assets/service-icons/chirurgia.svg" alt="" aria-hidden="true">Chirurgia</h3>
      <p>Zabiegi od kastracji po operacje wymagające większego doświadczenia, przeprowadzane w bezpiecznych warunkach i pod pełną kontrolą znieczulenia. Opiekujemy się pacjentem na każdym etapie - przed, w trakcie i po zabiegu.</p>
    </article>
    <article>
      <h3><img class="service-icon" src="assets/service-icons/diagnostyka.svg" alt="" aria-hidden="true">Diagnostyka obrazowa</h3>
      <p>USG i RTG pozwalają zajrzeć tam, gdzie nie sięga zwykłe badanie, i postawić trafną diagnozę szybciej. Mniej niepewności, szybsze leczenie.</p>
    </article>
    <article>
      <h3><img class="service-icon" src="assets/service-icons/stomatologia.svg" alt="" aria-hidden="true">Stomatologia</h3>
      <p>Zdrowe zęby to nie tylko ładny uśmiech - to mniej bólu i lepszy apetyt. Usuwamy kamień, leczymy i doradzamy, jak dbać o jamę ustną pupila na co dzień.</p>
    </article>
    <article>
      <h3><img class="service-icon" src="assets/service-icons/paszporty.svg" alt="" aria-hidden="true">Identyfikacja i paszporty</h3>
      <p>Zakładamy chipy i wystawiamy paszporty potrzebne do podróży z pupilem po Europie. Formalności bierzemy na siebie - Ty tylko planujesz wyprawę.</p>
    </article>
  </div>
</section>

<section class="section contact" id="kontakt">
  <div class="section-head">
    <p id="kontakt-heading" class="eyebrow anchor-target">Kontakt</p>
    <h2>Kontakt do wybranej filii</h2>
  </div>

  <div class="contact-grid">
    <article>
      <h3>{{ activeBranch.kind }} {{ activeBranch.title }}</h3>
      <p>{{ activeBranch.address }}</p>
      <p><strong>{{ activeBranch.phoneLabel }}:</strong> {{ activeBranch.phoneDisplay }}</p>
      <p *ngIf="activeBranch.extraPhone"><strong>Dodatkowy telefon:</strong> {{ activeBranch.extraPhone }}</p>
      <div class="hours-block hours-inline" *ngIf="activeBranch.hours?.length">
        <p class="hours-title">Godziny:</p>
        <ul class="hours-list">
          <li *ngFor="let hour of activeBranch.hours">{{ hour }}</li>
        </ul>
      </div>
      <a class="btn btn-primary" [href]="'tel:' + activeBranch.phoneHref">Zadzwoń teraz</a>
    </article>
  </div>
</section>

<section class="section maps" id="mapy">
  <div class="section-head">
    <p id="mapy-heading" class="eyebrow anchor-target">Dojazd</p>
    <h2 class="maps-heading">Dojazd do: {{ activeBranch.title }}</h2>
  </div>

  <div class="maps-grid">
    <article>
      <h3>{{ activeBranch.kind }} {{ activeBranch.title }}</h3>
      <p>{{ activeBranch.address }}</p>
      <a class="btn btn-secondary" target="_blank" rel="noopener noreferrer" [href]="activeBranch.mapUrl">Wyznacz trasę</a>
    </article>
  </div>
</section>
